import { StyleSheet } from "@react-pdf/renderer";

interface StyleSheetProps extends Record<string, any> {}

export const makePdfStyleSheet = (props?: StyleSheetProps) =>
  StyleSheet.create({
    page: {
      fontFamily: "Helvetica",
      fontStyle: "normal",
      lineHeight: 1.25,
    },
    body: {
      paddingHorizontal: "1.5cm",
      paddingVertical: "0.25cm",
      height: "29.7cm",
    },
    logo: {
      width: "80px",
      height: "120px",
      objectFit: "contain",
      alignSelf: "center",
      marginBottom: 32,
    },
    title: {
      alignSelf: "center",
      fontSize: 14,
      marginBottom: "0.4cm",
    },
    fontBold: {
      fontFamily: "Helvetica-Bold",
    },
    underlined: {
      textDecoration: "underline",
    },
    bodyText: {
      fontSize: 12,
    },
    footer: {
      fontSize: 10,
      marginTop: "auto",
    },
    uppercase: {
      textTransform: "uppercase",
    },
  });
